// import { useEffect, useState } from "react";
import { FETCH_CONTACTS_SEARCH_RESULTS } from "../../../../../graphql/query/Contact";
import {
  contactFilterStore,
  getContactSearchFromLocationSearch,
} from "../../../components/useContactFilters";

const SearchedContacts = props => {
  const { salesUserId } = props || {};
  const contactSearchFromUrl = getContactSearchFromLocationSearch(
    window.location.search,
  );
  const tableProps = {
    dataKey: "contactsV2",
    FETCH_QUERY: FETCH_CONTACTS_SEARCH_RESULTS,
    variables: {
      ...(contactSearchFromUrl ?? {}),
      ...(salesUserId ? { salesUserId } : {}),
    },
  };

  return tableProps;
};

export default SearchedContacts;
